import React from "react";
import "./ChartTabs.sass";

const VARIANT_FILL = "fill";

/**
 * Two or more tabs: of equal width over the whole row (Current / All of the
 * indicators and drawings menus, po-chart-visual-spec.md §5.1) or, as the
 * "pill" variant, rounded and as wide as their text (Inputs / Styles of the
 * indicator settings modal, §5.4).
 *
 * @param {object}   props
 * @param {Array<{ id: string, label: string, icon?: React.ReactNode }>} props.tabs - icon goes before the label
 * @param {string}   props.activeId
 * @param {(id: string) => void} props.onSelect
 * @param {"fill"|"pill"} [props.variant]
 */
const ChartTabs = ({ tabs, activeId, onSelect, variant = VARIANT_FILL }) => (
  <div className={`chart-tabs${variant === VARIANT_FILL ? "" : ` chart-tabs--${variant}`}`} role="tablist">
    {tabs.map(({ id, label, icon }) => {
      const isActive = id === activeId;

      return (
        <button
          key={id}
          type="button"
          role="tab"
          aria-selected={isActive}
          className={`chart-tabs__tab${isActive ? " chart-tabs__tab--active" : ""}`}
          onClick={() => onSelect(id)}
        >
          {icon && <span className="chart-tabs__tab-icon">{icon}</span>}
          {label}
        </button>
      );
    })}
  </div>
);

export default ChartTabs;
